import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MaterialModule } from '../../material/material.module';
import { CustomDropdownModule } from '../custom-dropdown/custom-dropdown.module';
import { ConfirmVoyageNumberComponent } from './confirm-voyage-number.component';



@NgModule({
  declarations: [ConfirmVoyageNumberComponent],
  imports: [
    CommonModule,
    MaterialModule,
    CustomDropdownModule,
    MatIconModule,
    FormsModule,

    ReactiveFormsModule,
  ],
   exports: [
    ConfirmVoyageNumberComponent
  ]
})
export class ConfirmVoyageNumberModule { }
